module.exports = __webpack_public_path__ + "static/media/IEEE.7c37cdee.png";